import { RootState } from "infrastructure/store";

export const selectAuthStatus = (state: RootState) => state.auth.status;

export const selectAuthUser = (state: RootState) => state.auth.user;
